export default __webpack_public_path__ + "assets/card-logo-hiper-component.49b4e072.svg";